// @flow
import { CANCEL } from 'redux-saga';

export function cancelRequest(promise: any) {
  if (typeof promise === 'object' && typeof promise[CANCEL] === 'function') {
    promise[CANCEL]();
  }
}

export default cancelRequest;



// WEBPACK FOOTER //
// ./src/common/network/cancelRequest.js